//Built-In
import React, {Fragment} from 'react';
//External
import {connect} from "react-redux";
//Internal
import Common from "../../Common/Common";
import {convertUTCToLocalTime, getConnectionStatus, loadCustomFormData, showToast} from "../../Common/Appcommon";
import {setFormDetails} from "../../reducers/ThemeOptions";
import ListTable from "../../Common/ListTable";
import CommonHeaderContent from "../../Common/CommonHeaderContent";
import {Button} from "reactstrap";
import cx from "classnames";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleInfo} from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import CratioTooltip from "../../Common/CratioTooltip";
import {statusSearchOptions} from './Constants'
import {faCirclePlus} from "@fortawesome/free-solid-svg-icons/faCirclePlus";

class Campaigns extends React.Component {
    formname = process.env.REACT_APP_CAMPAIGN_FORMNAME;
    hasMore = false;
    constructor(props) {
        super(props);
        let searchCondition = "nondate@"+this.formname+"@Status@is@Draft@OR#";
        searchCondition += "nondate@"+this.formname+"@Status@is@Scheduled@OR#";
        searchCondition += "nondate@"+this.formname+"@Status@is@Progress@OR#";
        searchCondition += "nondate@"+this.formname+"@Status@is@Processing@AND#";
        let advancedSearch = {
            advanced_search_key :searchCondition,
            STARTC : "true"
        }
        this.state = {
            formData : [],
            showLoader : false,
            listFields : [],
            page:1,
            limit:50,
            totalCount : 200,
            advancedSearch : advancedSearch,
            connectionStatus : "",
            hideSchudleDate : false,
            filterTxt : "",
            searchTxt : "",
            selectOption : statusSearchOptions[0].value
        }
    }

    componentDidMount = async () => {
        this.setState({
            showLoader : true
        })
        await this.loadFormData();
        let response = await getConnectionStatus();
        let connection = "";
        if(response.issuccess) {
            let data = response.data;
            connection = data['connection'];
        }
        this.setState({
            showLoader : false,
            connectionStatus : connection
        })
    };

    loadFormData = async (showLoader = false,skipAppending=false,resetPagination = false) => {
        if (showLoader) {
            this.setState({
                showLoader: true
            })
        }
        let page = this.state.page;
        if (resetPagination) {
            this.setState({page: 1});
            page = 1;
            this.hasMore = true;
        }
        const {rowData, listFields, totalCount} =
            await loadCustomFormData(
                true,
                this.formname,
                this.state,
                true
            );
        let newRowData = [];
        rowData.map((row) => {
            if (row['Type'] === 'Campaign') {
                newRowData.push(row);
            }
        });
        this.setState({
            formData: skipAppending ? newRowData : [...this.state.formData, ...newRowData],
            listFields: listFields,
            totalCount: totalCount,
            showLoader: false
        })
    }

    openNewCampaign = async(e)=>{
        window.location.href = "#/campaign/new";
    }
    initiateEditCampaign = async(e, campaignId) => {
        window.location.href = "#/campaign/edit/"+campaignId;
    }

    searchChangeHandler = async(e) => {
        let {filterTxt, searchTxt} = this.state;
        let filterVal = e.value;
        let searchCondition = "";
        if(filterVal !== undefined){
            if(filterVal === "All"){
                searchCondition = "nondate@"+this.formname+"@Status@is@Draft@OR#";
                searchCondition += "nondate@"+this.formname+"@Status@is@Scheduled@OR#";
                searchCondition += "nondate@"+this.formname+"@Status@is@Progress@OR#";
                searchCondition += "nondate@"+this.formname+"@Status@is@Processing@AND#";
            }else if(filterVal !== undefined && filterVal !== ''){
                if(filterVal === "Progress"){
                    searchCondition = "nondate@"+this.formname+"@Status@is@Progress@OR#";
                    searchCondition += "nondate@"+this.formname+"@Status@is@Processing@AND#";
                }else{
                    searchCondition = "nondate@"+this.formname+"@Status@is@"+filterVal+"@AND#";
                }
            }
            filterTxt = searchCondition;
        } else {
            filterVal = e.target.value;
            if(filterVal !== undefined && filterVal === ''){
                searchCondition = "nondate@"+this.formname+"@Name@is not empty@"+filterVal+"@AND#";
            }else{
                searchCondition = "nondate@"+this.formname+"@Name@contains@"+filterVal+"@AND#";
            }
            searchTxt = searchCondition;
        }
        let advancedSearch = {
            advanced_search_key :filterTxt+searchTxt,
            STARTC : "true"
        }
        await this.setState({
            advancedSearch : advancedSearch,
            filterTxt,
            searchTxt,
            selectOption : filterVal
        });
        await this.loadFormData(true, true);
    }

    deleteCallBack = () => {
        showToast("Deleted Successfully!",'top-right','success');
        this.loadFormData(true, true);
    }

    renderElements =  (name,formData,fields,childprops,childstate) => {

        if(name === 'statusBadge'){
            let fieldvalue = formData['Status'];
            let bclass = 'bg-success';
            if(fieldvalue == 'Draft'){
                bclass = 'bg-info';
            } else if (fieldvalue == 'Scheduled' || fieldvalue == 'Progress' || fieldvalue === 'Processing'){
                bclass = 'bg-warning';
            } else if (fieldvalue == 'Completed'){
                bclass = 'bg-success';
            } else if (fieldvalue == 'InReview'){
                fieldvalue = "Stoped";
                bclass = 'bg-danger';
            }
            return (
                <>
                    <div className={`ml-1 badge rounded-pill ${bclass}`}>
                        {fieldvalue}
                    </div>
                </>
            )
        } else if (name === "nameInfo"){
            let fieldvalue = formData['Name'];
            let createdBy = formData['Created Username'];
            let updatedOn = formData['updatedon'];
            if(updatedOn !== ""){
                updatedOn = convertUTCToLocalTime(updatedOn);
            }
            let tooltiptxt = "Last Updated User/ Time";
            return (
                <>
                    <div className={`d-grid text-left`}>
                        <span className={'template-primary'}>{fieldvalue}</span>
                        <CratioTooltip title={tooltiptxt} content={<span className={'template-secondary'} >{createdBy}, {updatedOn}</span>} />
                    </div>
                </>
            )
        }
    }

    render(){
        let {formData, selectOption} = this.state;
        let fields = this.state.listFields;
        if(this.state.listFields === undefined){
            return <></>
        }
        let customRowConfig = {
            link : {
                onClick : this.initiateEditCampaign,
                condition : "Status#Draft,Scheduled",
                class : "row-link"
            }
        }
        let connectionStatus = this.state.connectionStatus;
        let connectMsg = "";
        if(connectionStatus === ""){
            //connectMsg = "You have to connect Cloud API to send Campaign";
        }/* else if (connectionStatus === "sandbox"){
            connectMsg = "You are connected in Sandbox mode connect your own number with Whatsapp Cloud API.";
        }*/
        let customFieldConfig = {
            Status:{
                "render" : "statusBadge",
                "class" : "w-2"
            },
            createdon : {
                toLocalDate : true
            },
            Schedule_Time : {
                toLocalDate : true
            },
            Name : {
                "class" : "campaign-name w-1",
                "render" : "nameInfo"
            }
        };
        let headerFieldConfig = {
            CAMPAIGN : {
                "class" : "campaign-name w-1"
            },
            "SCHEDULED/ SENT AT" : {
                "class" : "w-4"
            },
            STATUS : {
                "class" : "w-5"
            }
        };

        return (
            <Common pageTitle={"Campaigns"} showLoader={this.state.showLoader}  mainContent={
                <Fragment>
                    <CommonHeaderContent
                        headerMsg={connectMsg}
                        isStatusFilter={true}
                        isSearchBox={true}
                        selectOptions={statusSearchOptions}
                        prefix={'campaigns'}
                        searchChangeHandler={this.searchChangeHandler}
                        searchChangeNameHandler={this.searchChangeHandler}
                        buttonAction={this.openNewCampaign}
                        buttonIcon={faCirclePlus}
                        headerTitle={'Campaigns'}
                        buttonTxt={'New Campaign'}
                        mainContent={
                        <div className={'main-card card mh-350'}>
                            <div className={''}>
                                <ListTable
                                    key={Math.random()}
                                    formData={formData}
                                    fields={fields}
                                    showRowCount={true}
                                    customRowConfig={customRowConfig}
                                    formName={this.formname}
                                    isDeleteNeeded={selectOption !== "All" && selectOption !== "Progress"}
                                    deleteCallBack={this.deleteCallBack}
                                    viewNeeded={false}
                                    analyticsNeeded={true}
                                    config={customFieldConfig}
                                    renderElements={this.renderElements}
                                    prefix={'campaigns'}
                                    accordianName={'campaign-analytics'}
                                    customClass={'no-border-table'}
                                    headerConfig={headerFieldConfig}
                                    defaultaccordianStatus={false}
                                />
                            </div>
                        </div>
                    } />
                </Fragment>
            } />
        )
    }

}

const mapStateToProps = state => ({
    formDetails: state.ThemeOptions.formDetails
});

const mapDispatchToProps = dispatch => ({
    setFormDetails: formDetail => dispatch(setFormDetails(formDetail)),
});
export default  connect(mapStateToProps, mapDispatchToProps) (Campaigns);
